<div class="hmt-custom-dropdown" [class.disabled]="disabled" [style.width]="width">
  <div 
    class="dropdown-trigger" 
    [class.active]="isOpen"
    [style.height]="height"
    [style.border-color]="borderColor"
    (click)="toggleDropdown()">
    <span class="selected-text" [style.color]="textColor">{{ selectedLabel }}</span>
    <div class="dropdown-arrow">
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" [attr.stroke]="textColor || 'var(--dropdown-arrow-color)'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <div class="dropdown-menu" *ngIf="isOpen">
    <div 
      class="dropdown-item" 
      *ngFor="let option of options"
      [class.selected]="isSelected(option)"
      [style.color]="textColor"
      (click)="selectOption(option)">
      <span>{{ option.label }}</span>
    </div>
  </div>
</div>

